export class User {
    session_d: string;
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    token?: string;
    mobile_no : string;
    first_name :string;
}

export class packageJsonModel {
    serviceItemCode: any;
    dependent_services:any;
    identifier: any;
    serviceIdCodeRemastered: any;
    serviceId: any;
    booking_from_days:any;
    booking_to_days:any;
    serviceName: any;
    speciality_id:any;  // add new speciality_id
    isConsentRequired: any;
    department_id: any;
    department_name: any;
    schedulable: any;
    kyc_required: any = "";
    facility_name: any;
    subDepartment_id: any;
    subDepartment_name: any;
    priority: any;
    priorityCode: any;
    serviceItemName: any;
    serviceType: any;
    order_frequency: any;
    serviceType_code: any;
    payer_id: any;
    facility_id: any;
    payerDetails: any;
    quantity: any = "1";
    package_type: any;
    package_type_code: any;
    package_sub_type_code: any;
    package_sub_type: any;
    limit_per_day:any;
    single_visit: boolean = false;
    auto_scheduling: boolean;
    billing: any;
    helping_id: any;
    template_id: any;
    template_name: any;
    template_type: any;
    template_title: any;
    is_reappliable: any;
    non_modifiable: any;
    allow_multiple_consumption: boolean;
    reappliable: any;
    reappliable_limit: any = 0;
    reappliable_time_period: any = 0;
    token_at: any = "";
    phc_reason:any = "";
    service_code: any;
}


export class packageData {
    serviceDate: any;
    limit_per_day: any;
    slotDate: any;
    slotEndDate:any;
    price: any;
    discount_price: any;
    slots: any;
    net_amount: any;
    scheme_name: any;
    isConsentRequired: any;
    slotId: any;
    slotStartTime: any;
    identifier:any;
    slotEndTime: any;
    slotNo: any;
    package_type:any;
    speciality_id:any;
    serviceStartTime: any = 0;
    serviceEndTime: any = 0;
    service_code:any;
    over_booking_status: any;
    scheme_id: any;
    patient_instructions:any;
    nurse_remark:any;
    tariff_amount: any;
    is_group_limit_applicable: any;
    scheme_discount_applicable: any;
    payer_amount: any;
    paymentStatus: any;
    final_payable: any;
    patient_amount: any;
    service_mrp: any;
    emergency_charges: any;
    service_selling_amount: any;
    common_tax_detail: any;
    tax: any;
    billing_category_id: any;
    billing_category_name: any;
    disabledComponent: boolean = false;
}